import _classCallCheck from "/Users/och/Downloads/contentlab_frontend-main-1/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/Users/och/Downloads/contentlab_frontend-main-1/node_modules/@babel/runtime/helpers/esm/createClass";
import { TwinkleValues } from "./TwinkleValues";
export var Twinkle = /*#__PURE__*/function () {
  function Twinkle() {
    _classCallCheck(this, Twinkle);
    this.lines = new TwinkleValues();
    this.particles = new TwinkleValues();
  }
  _createClass(Twinkle, [{
    key: "load",
    value: function load(data) {
      if (data === undefined) {
        return;
      }
      this.lines.load(data.lines);
      this.particles.load(data.particles);
    }
  }]);
  return Twinkle;
}();